import React, { useEffect, useRef } from 'react';
import { Animated, Easing, View } from 'react-native';

import Icon from '@components/shared/Icon/Icon';
import theme from '@themes/theme';

export function PulsingHashButton() {
  const pulseAnim = useRef(new Animated.Value(0)).current;
  const enterAnim = useRef(new Animated.Value(0)).current;
  const pulseActive = useRef(true);

  const runPulse = () => {
    if (!pulseActive.current) return;
    pulseAnim.setValue(0);
    Animated.timing(pulseAnim, {
      toValue: 1,
      duration: 1100,
      easing: Easing.out(Easing.ease),
      useNativeDriver: true,
    }).start(({ finished }) => {
      if (finished && pulseActive.current) runPulse();
    });
  };

  useEffect(() => {
    Animated.timing(enterAnim, {
      toValue: 1,
      duration: 400,
      easing: Easing.out(Easing.cubic),
      useNativeDriver: true,
    }).start();
    pulseActive.current = true;
    runPulse();
    return () => {
      pulseActive.current = false;
      pulseAnim.stopAnimation();
      enterAnim.stopAnimation();
    };
  }, []);

  return (
    <View
      style={{
        width: 40,
        height: 40,
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      {/* Ripple ring — expands 1→2 and fades out */}
      <Animated.View
        style={
          {
            position: 'absolute',
            width: 40,
            height: 40,
            borderRadius: 20,
            backgroundColor: theme.colors.greenSecondary,
            opacity: pulseAnim.interpolate({
              inputRange: [0, 1],
              outputRange: [0.55, 0],
            }),
            transform: [
              {
                scale: pulseAnim.interpolate({
                  inputRange: [0, 1],
                  outputRange: [1, 2],
                }),
              },
            ],
          } as any
        }
      />
      {/* Solid green circle — enters with scale+fade, stays fixed */}
      <Animated.View
        style={
          {
            width: 40,
            height: 40,
            borderRadius: 20,
            backgroundColor: theme.colors.greenSecondary,
            alignItems: 'center',
            justifyContent: 'center',
            opacity: enterAnim,
            transform: [
              {
                scale: enterAnim.interpolate({
                  inputRange: [0, 1],
                  outputRange: [0.7, 1],
                }),
              },
            ],
          } as any
        }>
        <Icon name='Hash' color='white' width={20} height={20} />
      </Animated.View>
    </View>
  );
}
